import React from "react";
import { AppContext } from "../context/AppProvider";

export const useAppContext = () => {
    return React.useContext(AppContext);
};
